// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__ofZ0M","wrapper_rounded":"styles_wrapper_rounded__KCYgy","footer":"styles_footer__xEYW_","carouselContainer":"styles_carouselContainer__EA5mM"};